<template>
  <b-modal 
			id="modal-asignarCertificado"
			@show="resetModal"
			@ok="handleEnvio"
		>
	
    <template v-slot:modal-title>
      <label>Asignar certifcado</label>
    </template>
    <b-form-group label="Selecciona el certificado">
			<b-form-select
				v-model="selectCertificado"
				:options="optionCertificado"
				@change="changeValorCertificado()"
			>
			</b-form-select>
				<span v-if="error.idCertificado" style="color:red">
					 {{ `Certificado ${error.idCertificado[0]}` }}
					<br />
				</span>
		</b-form-group>

    <b-form-group label="Selecciona el curso">
			<v-select
				:options="jsonCurso"
				label="tituloCurso"
				v-model="selectCurso"
        placeholder="Haa click para seleccionar el curso..."
				@input="changeModulo()"
			>
			</v-select>
			<span v-if="error.idCurso" style="color:red">
					 {{ `Selección curso ${error.idCurso[0]}` }}
					<br />
				</span>
		</b-form-group>
    <b-form-group label="Selecciona el modulo">
			<b-form-select
				v-model="selectModulo"
				:options="optionModulo"
				:disabled="booleanModulo"
			>
			</b-form-select>
		</b-form-group>
		<template v-slot:modal-footer="{ ok, cancel }">
			<b-button @click="cancel()">
				Cancelar
			</b-button>
			<b-button variant="primary" @click="ok()">
				Aceptar
			</b-button>
		</template>
		<toast ref="toast"/>
  </b-modal>
</template>

<script>
import toast from "@/components/toastComponent";
import { mapState, mapActions } from "vuex";
export default {
	components:{
		toast
	},
  data(){
    return{
      selectCertificado:null,
      optionCertificado:[],
      selectCurso: "",
      selectModulo: 0,
      optionModulo: [],
      booleanModulo: true,
			optionsCurso:[],
			error:{
				idCertificado:'',
				idCurso:''
			}
    }
  },
  computed:{
    ...mapState("curso", ["jsonCurso"]),
    ...mapState("certificado",["jsonCertificado"])
  },
  methods:{
			changeValorCertificado(){
				this.error.idCertificado = '';
			},
			handleEnvio(bvModalEvt) {
			// Prevent modal from closing
			bvModalEvt.preventDefault();
			this.asignarCertificado();
		},
		asignarCertificado(){
			const form = {
				idCertificado : this.selectCertificado,
				idCurso : this.selectCurso ? this.selectCurso.idCurso : null,
				idModulo : this.selectModulo
			}

			this.axios
				.post('api/createAsignacionCertificado',form)
				.then(res=>{
					if (res.data.errores) {
						this.error = res.data.errores;
					}
					
					if(res.data.msg == "encuestaAsignacion"){
						const certificado = this.jsonCertificado.find(
								elem =>
									elem.idCertificado ==
									form.idCertificado
						);
						const curso = certificado ? certificado.curso.push(res.data.curso) : null;
						const arrayToast = {
							msg: "Se ha asignado el certificado con exito",
							title: "Asignacion certificado",
							variant: "success"
						};
						this.$refs.toast.makeToast(arrayToast);
					}
			}); 
		},
    getInfoModal(){
			this.optionCertificado = [
				{value:null, text:"Haz click para seleccionar el certificado..."}
			]
			 this.jsonCertificado.map(elem=>{
				 this.optionCertificado.push({value:elem.idCertificado, text:elem.nombreCertificado})
			 });
    },  
    changeModulo() {
			this.getModuloCurso(this.selectCurso.idCurso);
			this.booleanModulo = false;
			this.error.idCurso = '';
    },
    getModuloCurso(idCurso) {
			
			this.axios
				.get("api/getTotalModulos/" + idCurso)
				.then(res => {
					const listadoModulos = res.data.modulos;
					const modulos = [
						{ value: null, text: "Haz click para seleccionar un modulo." }
					];
					listadoModulos.map(elem =>
						modulos.push({ value: elem.idModulo, text: elem.nombre })
					);
					this.optionModulo = modulos;
					this.selectModulo = this.optionModulo[0].value;
				})
				.catch(err => console.log(err));
		},
		resetModal() {
				this.selectCertificado = null
				this.selectCurso = null
				this.selectModulo = null
		}
  }
}
</script>